export default __webpack_public_path__ + "static/media/info.68bb4d6d.svg";